@if (!ediEnabled) {
  <div class="alert alert-warning d-flex align-items-center" role="alert">
    <i class="fa-solid fa-circle-info me-2"></i>
    <span>{{ 'PUNCHOUT_ORDER_INTAKE_REQUIRES_EDI' | translate }}</span>
  </div>
}

<div class="d-flex justify-content-end align-items-end flex-wrap gap-2 mb-2">
  <div>
    <label class="form-label mb-0 small" for="punchout-order-requests-from">{{ 'DATE_FROM' | translate }}</label>
    <input
      id="punchout-order-requests-from"
      type="date"
      class="form-control form-control-sm"
      [value]="fromDate"
      [max]="toDate"
      (change)="onFromDateChange($any($event.target).value)"
    />
  </div>
  <div>
    <label class="form-label mb-0 small" for="punchout-order-requests-to">{{ 'DATE_TO' | translate }}</label>
    <input
      id="punchout-order-requests-to"
      type="date"
      class="form-control form-control-sm"
      [value]="toDate"
      [min]="fromDate"
      (change)="onToDateChange($any($event.target).value)"
    />
  </div>
  <button type="button" class="btn btn-outline-secondary" (click)="refresh()">
    <i class="fa-solid fa-rotate-right me-2"></i>
    <span>{{ 'REFRESH' | translate }}</span>
  </button>
</div>

@if (rangeInvalid) {
  <div class="alert alert-warning py-1 px-2 small">
    {{ 'PUNCHOUT_AUDIT_DATE_RANGE_INVALID' | translate }}
  </div>
}

<lib-filter-list [configService]="config"></lib-filter-list>
